import React, { useState } from 'react'
import { toast } from 'react-toastify';

function Home2() {
    const [formData, setFormData] = useState({
        Email: '',
        Name: '',
        Organization: '',
        Designation: '',
    });

    const [submitting, setSubmitting] = useState(false);

    // Simple email regex for format validation
    const isValidEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };

    const handleChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Trim all fields first
        const { Email, Name, Organization, Designation } = {
            Email: formData.Email.trim(),
            Name: formData.Name.trim(),
            Organization: formData.Organization.trim(),
            Designation: formData.Designation.trim()
        };

        // 🔸 Field Validations
        if (!Email) {
            toast.error('Email is required!');
            return;
        }
        if (!isValidEmail(Email)) {
            toast.error('Please enter a valid email address!');
            return;
        }
        if (!Name) {
            toast.error('Name is required!');
            return;
        }
        if (!Organization) {
            toast.error('Organization is required!');
            return;
        }
        if (!Designation) {
            toast.error('Designation is required!');
            return;
        }

        setSubmitting(true);

        try {
            const res = await fetch('https://industech-backend.vercel.app/api/admin/AddContactUs', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ Email, Name, Organization, Designation }),
            });

            if (res.ok) {
                toast.success('Subscribed successfully!');
                setFormData({ Email: '', Name: '', Organization: '', Designation: '' });
            } else {
                toast.error('Something went wrong. Try again!');
            }
        } catch (err) {
            console.error(err);
            toast.error('Error occurred while submitting.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <div className='bg-home'>
                <div className="flex items-center lg:pb-[120px] pb-[80px] gap-[36px] w-full justify-between lg:flex-row flex-col">
                    <div className='max-w-[724px] w-full'>
                        <h1 className=" font-[400] font-playfair lg:text-[91px] text-[40px] lg:leading-[95px] leading-[50px] tracking-[-0.42px] text-[#FFFFFF] pb-[26px]">IndUS Tech is Relaunching</h1>
                        <p className="font-[700] font-playfair lg:text-[60px] text-[30px] tracking-[1px] text-[#BB872A] pb-[8px]">The Corridor is Evolving</p>
                        <p className="max-w-[579px] w-full font-playfair font-[400] lg:text-[24px] text-[16px] tracking-[-0.6px] pb-[16px] text-[#FFFFFF]">Trust still powers the corridor. Now, we are building what comes next.</p>
                        <p className="max-w-[579px] w-full font-playfair font-[400] lg:text-[24px] text-[16px] tracking-[-0.6px] pb-[16px] text-[#FFFFFF]">IndUS Tech is a platform for dual-use strategy where capital, innovation, and policy align with intent.</p>
                        <p className="font-[400] font-playfair lg:text-[24px] text-[16px] tracking-[-0.6px] lg:pb-[30px] pb-[16px] text-[#FFFFFF]">We make the corridor work.</p>
                        <p className="font-[400] font-playfair lg:text-[24px] text-[16px] tracking-[-0.6px] lg:pb-[30px] pb-[16px] text-[#FFFFFF]">We structure the right pathways, partners, and capital.</p>
                        <p className="font-[400] font-playfair lg:text-[24px] text-[16px] tracking-[-0.6px] lg:pb-[30px] pb-[16px] text-[#FFFFFF]">We build quietly and with consequence.</p>
                    </div>
                    <div className="max-w-[520px] w-full bg-[#14123C66] border border-[#3A385A] lg:p-[40px] p-[20px] lg:pb-[55px] pb-[30px] rounded-[2px]">
                        <h6 className="font-[600] font-playfair lg:text-[40px] text-[30px] tracking-[-0.5px] text-[#FFFFFF] lg:pb-[21px] pb-[10px]">Stay Aligned</h6>
                        <p className="font-[400] font-playfair lg:text-[25px] text-[20px] tracking-[0.5px] text-[#FFFFFF] lg:pb-[33px] pb-[20px]">Get notified when we go live.</p>
                        <form onSubmit={handleSubmit} className="flex flex-col gap-[20px]">
                            <input
                                type="email"
                                name="Email"
                                className='border border-[#FFFFFF] rounded-[28.5px] py-[14px] px-[29px] font-outfit font-[400] text-[18px] text-[#ffffff] bg-transparent'
                                placeholder='Email'
                                value={formData.Email}
                                onChange={handleChange}
                            />
                            <input
                                type="text"
                                name="Name"
                                className='border border-[#FFFFFF] rounded-[28.5px] py-[14px] px-[29px] font-outfit font-[400] text-[18px] text-[#ffffff] bg-transparent'
                                placeholder='Name'
                                value={formData.Name}
                                onChange={handleChange}
                            />
                            <input
                                type="text"
                                name="Organization"
                                className='border border-[#FFFFFF] rounded-[28.5px] py-[14px] px-[29px] font-outfit font-[400] text-[18px] text-[#ffffff] bg-transparent'
                                placeholder='Organization'
                                value={formData.Organization}
                                onChange={handleChange}
                            />
                            <input
                                type="text"
                                name="Designation"
                                className='border border-[#FFFFFF] rounded-[28.5px] py-[14px] px-[29px] font-outfit font-[400] text-[18px] text-[#ffffff] bg-transparent'
                                placeholder='Designation'
                                value={formData.Designation}
                                onChange={handleChange}
                            />
                            <button
                                type="submit"
                                disabled={submitting}
                                className='lg:mt-[20px] w-full text-center py-[15px] bg-[#BB872A] border-[#BB872A] text-[#FFFFFF] transition-all duration-300 rounded-[40px] font-[400] font-outfit text-[18px] tracking-[-0.5px]'
                            >
                                {submitting ? 'Submitting...' : 'Subscribe to DOT Weekly'}
                            </button>
                        </form>
                    </div>
                </div>
                <div className='border-t border-[#6C6C6C] pt-[32px] lg:pb-[60px] pb-[30px]'>
                    <p className="font-[400] font-playfair text-[18px] leading-[28px] text-[#FFFFFF]">©2025 IndUS Tech. All Rights Reserved </p>
                </div>
            </div>
        </>
    )
}

export default Home2